import { Modal, Space, Typography } from 'antd';
import { useMemo } from 'react';

import type { TemplateApplyingDialogType } from '@pages/Users/AccessRightsTab/types';

const { Text } = Typography;

export const TemplateApplyingDialog: TemplateApplyingDialogType = ({
  isOpened,
  isLoading,
  selectedTemplate,
  onOk,
  onCancel,
}) => {
  const name = useMemo(
    () => selectedTemplate?.Name || 'Безымянный',
    [selectedTemplate]
  );

  const description = useMemo(
    () => selectedTemplate?.Description || 'без описания',
    [selectedTemplate]
  );

  return (
    <Modal
      title="Применение шаблона прав"
      open={isOpened}
      confirmLoading={isLoading}
      okText="Применить"
      cancelText="Отменить"
      onOk={onOk}
      onCancel={onCancel}
    >
      <Space direction="vertical">
        <Text>
          Вы уверены, что хотите применить права доступа из шаблона «{name}»?
        </Text>
        {description && (
          <Space>
            <Text strong>Описание шаблона:</Text>
            <Text>«{description}».</Text>
          </Space>
        )}
      </Space>
    </Modal>
  );
};
